import { render, staticRenderFns } from "./TodoUserGroupChooser.vue?vue&type=template&id=f6f5daf4"
import script from "./TodoUserGroupChooser.vue?vue&type=script&lang=js"
export * from "./TodoUserGroupChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports